import { useSyncExternalStore } from 'react'

// UI ticks synthesized with Web Audio: no audio files to download. On by default, but browsers
// keep audio silent until the visitor's first click or key press on the page.
let on = true
let ctx = null

// Hover isn't a user gesture, so the context is unlocked inside the first real one.
function unlock() {
  ctx ??= new AudioContext()
  ctx.resume()
}
for (const type of ['pointerdown', 'keydown', 'touchend']) {
  window.addEventListener(type, unlock, { once: true, capture: true })
}

const listeners = new Set()

function subscribe(listener) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

function toggleSound() {
  on = !on
  listeners.forEach((l) => l())
  tick(660)
}

export function useSound() {
  return [useSyncExternalStore(subscribe, () => on), toggleSound]
}

export function tick(frequency = 880) {
  if (!on || !ctx) return
  const osc = ctx.createOscillator()
  const gain = ctx.createGain()
  osc.frequency.value = frequency
  gain.gain.setValueAtTime(0.04, ctx.currentTime)
  gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.08)
  osc.connect(gain).connect(ctx.destination)
  osc.start()
  osc.stop(ctx.currentTime + 0.09)
}
